import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DeliveryPromiseRestrictionRules } from '@pages/checkout-app/components/sections/delivery-promise/delivery-promise-restrictions/config';
import { ShopService } from '@services/shops/shop.service';
import { RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

@Component({
  selector: 'delivery-promise-restrictions',
  standalone: false,
  templateUrl: './delivery-promise-restrictions.component.html',
  styleUrl: './delivery-promise-restrictions.component.scss',
})
export class DeliveryPromiseRestrictionsComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  deliveryPromiseRestrictionRules = [...DeliveryPromiseRestrictionRules];
  deliveryPromiseRestrictionEntities: string[] = [];
  optionsInitialized = false;
  private destroyRef = inject(DestroyRef);

  constructor(private shopService: ShopService) {}

  ngOnInit(): void {
    this.buildLocationsOptions();
    this.deliveryPromiseRestrictionEntities = this.deliveryPromiseRestrictionRules.map((r) => r.entity);
  }

  onRuleRemove(event): void {
    if (event?.remaining === 0) {
      this.formGroup.get('deliveryPromiseRestriction.enabled').setValue(false);
    }
  }

  buildLocationsOptions(): void {
    this.shopService.shop$
      .pipe(
        filter((shop) => !!shop),
        tap(() => (this.optionsInitialized = true)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((shop) => {
        const entityIndex = this.deliveryPromiseRestrictionRules.findIndex(
          (r) => r.entity === RuleEntity.UNFULFILLED_ORDERS,
        );
        const entityParamIndex = this.deliveryPromiseRestrictionRules[entityIndex].entityParams.findIndex(
          (e) => e.name === 'locationIdsValue',
        );
        this.deliveryPromiseRestrictionRules[entityIndex].entityParams[entityParamIndex].options = shop.shopLocations
          .sort((l) => +l.isPrimaryLocation)
          .map((location) => {
            return {
              label: location.storeName,
              value: location.id,
            };
          });
      });
  }
}
